import "styles/page.css";

import { handleOpenPdf } from "utils";
import { LinkButton } from "components/buttons";
import { ASSETS_BASE_URL } from "constants";
function Disclosure() {
  return (
    <>
      <div className="container page">
        <h1 className="page-title" style={{ color: "#000045" }}>
          Corporate Governance Disclosure
        </h1>

        <p className="page-subtitle" style={{ color: "#72788E" }}>
          In compliance with the Bank Negara Malaysia’s policy document on
          Corporate Governance which came into effect on 3 August 2016, Al Rajhi
          Banking & Investment Corporation (Malaysia) Berhad (ARBM) appends
          herewith the following documents:-
          <br></br>
          <br></br>
          <b>Articles of Association</b>
          <br></br>
          ARBM adheres to the sound corporate governance and ethical standards
          practices under the leadership of the Board, as guided by its Articles
          of Association and other applicable regulations.
          <br></br>
          <br></br>
          <b>Board Charter</b>
          <br></br>
          The Board Charter of ARBM sets out the mandate, responsibilities and
          procedures of its board and the board committees, including the
          matters reserved for the Board's decision.
        </p>

        <div className="link-button-row">
          <LinkButton
            text={"Articles of Association"}
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/Association.pdf`)}
          />
          <LinkButton
            text={"Board Charter"}
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/BoardCharter.pdf`)}
          />
        </div>
      </div>
    </>
  );
}

export default Disclosure;
